export interface ChangelogEntry {
  version: string;
  date: string;
  changes: string[];
}

export const changelog: ChangelogEntry[] = [
  {
    version: '0.9.1',
    date: '2026-05-20',
    changes: [
      'Fixed the issue where seats are not displayed after joining a room',
      'Fixed an issue where some players mistakenly entered the viewing angle after the game started.',
      'Fixed the problem of ghost online spectators appearing in the spectator seats after kicking offline players',
      'Players who are disconnected at the end of a round will now automatically vote for the next round',
    ],
  },
  {
    version: '0.9.0',
    date: '2026-05-19',
    changes: [
      'Client update detection: Caddy automatically prompts to refresh after restarting',
      'Avatar cropping supports custom rotation angles',
      'Registration/login security enhancement',
      'Bot Name library expanded to 156',
      'Fixed issues such as avatar cropping blanks, floating panel style, etc.',
    ],
  },
  {
    version: '0.8.0',
    date: '2026-05-19',
    changes: [
      'Game timer: real-time display of turn timing and delay',
      'Mobile game layout adaptation and hosting mask',
      'Draggable floating panel, foldable player list',
      'Homeowners watching the game will automatically line up to be seated, and the host migration process is complete.',
      'Fixed the problem of end card restriction/win with empty hand not counting the game as stuck',
      'Reconnection stability and connection speed optimization',
    ],
  },
  {
    version: '0.7.0',
    date: '2026-05-16',
    changes: [
      'Room seating system: round table layout, 10 fixed seats determine the order of entry and exit',
      'Seat selection and seat change: Click on an empty seat to take a seat. Players can request to change seats and change seats directly with Bot.',
      'Seat right-click menu: You can take a seat in an empty seat or add a bot. Bot seats can be changed, adjusted in difficulty, and removed.',
      'The settings panel is changed to a slide-out drawer on the right side, and the mobile terminal adapts to zoom.',
      'Disconnection mark: Players who are disconnected will display an icon and automatically cancel preparations.',
    ],
  },
  {
    version: '0.6.0',
    date: '2026-05-16',
    changes: [
      'Added new Bot AI (human-machine) function to support adding Bots to fill empty spaces',
      'The lobby room list is changed to real-time push without manual refresh.',
      'Improved server latency measurement accuracy (Socket.IO ping/ack）',
      'Bot UI/UX Optimization: single-step hosting animation, homeowner migration logic',
    ],
  },
  {
    version: '0.5.1',
    date: '2026-05-15',
    changes: [
      'Performance optimization: The number of Bot round broadcasts is reduced from 2-6 times to 1 time',
      'Performance optimization: discard pile transfer truncation + client re-render greatly reduced',
      'The change log supports folding, and only the last 3 versions are displayed by default.',
    ],
  },
  {
    version: '0.5.0',
    date: '2026-05-15',
    changes: [
      'Full dependency upgrade: React 19, Vite 8, TypeScript 6, etc.',
      'Fix server-side test not relying on external Redis',
      'MCP The package has been published to npm',
    ],
  },
  {
    version: '0.4.0',
    date: '2026-05-14',
    changes: [
      'MCP Server：AI Clients can join the game through the MCP tool',
      '8-bit Programmed BGM system: hall music, room BGM, concert hall',
      'The auditorium has been completely redesigned: visual list, expression loss, UNO capture, join/exit buttons',
      'Added new grab-out village rules and random seat village rules',
      'When the deck is exhausted, it will automatically shuffle and recycle the discard pile.',
      'Automatic hosting after continuous timeout and kicking out unprepared players at the end of the round',
      'Anti-cheat system + full screen warning UI',
      'Player operation menu: hand over to the host, kick people, force mute, volume adjustment',
      'Browser notifications, server version update prompts',
      'Color selection light wave, +4 full screen effect',
      'Novice tutorial guide',
      'game over You can then return to the room to continue the game',
      'Start interface overlay + login and registration page redesign',
      'Fix client clock deviation causing countdown exception',
      'A large number of game logic fixes and experience optimization',
    ],
  },
  {
    version: '0.3.2',
    date: '2026-05-10',
    changes: [
      'The round settlement is changed to a voting system, and the next round will start only after more than half of the votes are received.',
      'The discard pile is fully synchronized, and the stacking effect of the last 8 cards is displayed on the desktop.',
      'Penalty drawing and card giving animations are changed to card drawing animations one by one',
      'UNO And grab UNO full screen special effects',
      'In-game sound effect feedback: card play, penalty card, prop hit',
      'The room automatically disbands when it is idle',
      'Chat history reconnection recovery',
      'Fixed multiple bugs such as stacking penalty touch, color change +4, spectator session recovery, etc.',
    ],
  },
  {
    version: '0.3.1',
    date: '2026-05-07',
    changes: [
      'The picture on the back of the small card below the avatar (hand card< 8 Zhang Shi)',
      'Replace mediasoup voice with Mumble architecture',
      "The voice speaker's avatar is highlighted in green, and the volume can be adjusted by person.",
      'Fixed the bug where shouting UNO before playing a card was overwritten',
      'Fixed the bug where wild cards could escape punishment under superimposed village rules',
    ],
  },
  {
    version: '0.3.0',
    date: '2026-05-07',
    changes: [
      'Management background: user management, room management, data statistics',
      'Four-level user role system (ordinary/member/VIP/administrator)',
      'Elliptical orbit highlighted arc segment + card direction arrow',
      "Round indicator: current player's avatar, nickname, countdown",
      'Hosting enhancements: automatic questioning +4, automatic color selection, automatic selection of exchange objects',
      'Rounded Corners/Technology Dual Style Theme',
      'Home page version number, game TopBar version number',
      'Fix passwordHash leak security vulnerability',
    ],
  },
  {
    version: '0.2.0',
    date: '2026-05-06',
    changes: [
      'Username and password registration and login, nickname system, avatar upload',
      'Oval round table layout: player nodes arranged around, countdown ring',
      'Chat bubbles, quick reactions, quick phrases, and prop-throwing interactions',
      'Poker-style card corners, fan-shaped hand layout, automatic sorting',
      'Autopilot (Bot), draw animation, room reconnection',
      'Migrate Tailwind CSS v4 dark theme',
      'Remove Prisma and use Kysely + SQLite instead',
    ],
  },
  {
    version: '0.1.0',
    date: '2026-05-06',
    changes: [
      'UNO Online initial version',
      'React Client + Node.js Server + shared game logic',
      'Development mode: Skip GitHub OAuth, login with username only',
      'Caddy Replace nginx, support automatic SSL',
    ],
  },
];
